import { clsx } from 'clsx';
import React from 'react';
import Box from '../Box/Box.js';
import { isResponsiveValue } from '../hooks/useResponsiveValue.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import classes from './Avatar.module.css.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DEFAULT_AVATAR_SIZE = 20;
const Avatar = /*#__PURE__*/React.forwardRef(function Avatar({
  alt = '',
  size = DEFAULT_AVATAR_SIZE,
  square = false,
  sx: sxProp = defaultSxProp,
  className,
  ...rest
}, ref) {
  const isResponsive = isResponsiveValue(size);
  const cssSizeVars = {};
  if (isResponsive) {
    for (const [key, value] of Object.entries(size)) {
      cssSizeVars[`--avatarSize-${key}`] = `${value}px`;
    }
  } else {
    cssSizeVars['--avatarSize-regular'] = `${size}px`;
  }
  if (sxProp !== defaultSxProp) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      as: 'img',
      "data-component": "Avatar",
      className: clsx(className, classes.Avatar),
      ref: ref,
      alt: alt,
      "data-responsive": isResponsive ? '' : undefined,
      "data-square": square ? '' : undefined,
      width: isResponsive ? undefined : size,
      height: isResponsive ? undefined : size,
      style: cssSizeVars,
      sx: sxProp
    }, rest));
  }
  return /*#__PURE__*/React.createElement("img", _extends({
    "data-component": "Avatar",
    className: clsx(className, classes.Avatar),
    ref: ref,
    alt: alt,
    "data-responsive": isResponsive ? '' : undefined,
    "data-square": square ? '' : undefined,
    width: isResponsive ? undefined : size,
    height: isResponsive ? undefined : size,
    style: cssSizeVars
  }, rest));
});
if (process.env.NODE_ENV !== "production") {
  Avatar.displayName = 'Avatar';
}

export { DEFAULT_AVATAR_SIZE, Avatar as default };
